module.exports = __webpack_public_path__ + "img/02baa95.jpg";